import {Col, Row} from "antd";
import {TFunction, withTranslation} from "react-i18next";
import {SvgIcon} from "../../common/SvgIcon";
import Container from "../../common/Container";

import i18n from "i18next";
import {Extra, LogoContainer, NavLink,} from "./styles";

interface SocialLinkProps {
    href: string;
    src: string;
}

const Footer = ({t}: { t: TFunction }) => {
    const handleChange = (language: string) => {
        i18n.changeLanguage(language);
    };

    const SocialLink = ({href, src}: SocialLinkProps) => {
        return (
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                key={src}
                aria-label={src}
            >
                <SvgIcon src={src} width="25px" height="25px"/>
            </a>
        );
    };

    return (
        <>
            <Extra>
                <Container border={true}>
                    <Row
                        justify="space-between"
                        align="middle"
                        style={{paddingTop: "3rem"}}
                    >
                        <NavLink to="/">
                            <LogoContainer aria-label="homepage">
                                <img src={require("../Header/JodiLogo.png")} alt="Jodi" style={{height: 40}}/>
                                <img src={require("../Header/JodiText.png")} alt="Jodi" style={{height: 50}}/>
                            </LogoContainer>
                        </NavLink>
                    </Row>

                    {/* Privacy Policy Link */}
                    <Row style={{paddingTop: "1rem", paddingBottom: "0rem"}}>
                        <Col>
                            <NavLink
                                to="/privacy-policy"
                                style={{fontWeight: "bold", textDecoration: "underline"}}
                            >
                                {t("Privacy Policy")}
                            </NavLink>
                        </Col>
                    </Row>


                    {/* Terms and Conditions Link */}
                    <Row style={{paddingTop: "0.5rem", paddingBottom: "0.5rem"}}>
                        <Col>
                            <NavLink
                                to="/terms-and-conditions"
                                style={{fontWeight: "bold", textDecoration: "underline"}}
                            >
                                {t("Terms and Conditions")}
                            </NavLink>
                        </Col>
                    </Row>

                    {/* Account Deletion Link */}
                    <Row style={{paddingTop: "0rem", paddingBottom: "0rem"}}>
                        <Col>
                            <NavLink
                                to="/support"
                                style={{fontWeight: "bold", textDecoration: "underline"}}
                            >
                                {t("Support")}
                            </NavLink>
                        </Col>
                    </Row>

                </Container>
            </Extra>
        </>
    );
};

export default withTranslation()(Footer);
